import { Moment } from 'moment';
import { apiGet, API_URI } from './index';

const deepDiveBreakdown = {
    getOwned: async (projectId: number, startDate: Moment, endDate: Moment, rail: string, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/deepdive/ownedcontent?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm")}&endDate=${endDate.format("DD MMM YYYY HH:mm")}&rail=${rail}&streamIds=${streamIds.join(',')}`);
        return data;
    },
}

export default deepDiveBreakdown;